import { render, staticRenderFns } from "./AlertNoticeList.vue?vue&type=template&id=049ef899&scoped=true&"
import script from "./AlertNoticeList.vue?vue&type=script&lang=js&"
export * from "./AlertNoticeList.vue?vue&type=script&lang=js&"
import style0 from "./AlertNoticeList.vue?vue&type=style&index=0&id=049ef899&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049ef899",
  null
  
)

export default component.exports